// import * from { class };

// inital JS load
(($) => {

    // when document ready,
    document.addEventListener('DOMContentLoaded', () => {

        if (document.querySelectorAll('.upcoming').length == 0) {
            return;
        }

        $('.upcoming__items').slick({
            infinite: true,
            mobileFirst: true,
            prevArrow: '<button type="button" class="slick-prev"><i class="fa-solid fa-chevron-left"></i> Prev</button>',
            nextArrow: '<button type="button" class="slick-next">Next <i class="fa-solid fa-chevron-right"></i></button>',
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToScroll: 4,
                        slidesToShow: 4
                    }
                },
                {
                    breakpoint: 896,
                    settings: {
                        slidesToScroll: 3,
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToScroll: 2,
                        slidesToShow: 2
                    }
                }
            ],
            slidesToScroll: 1,
            slidesToShow: 1
        }).on('beforeChange', function (event, slick, currentSlide, nextSlide) {

            if (null === slick.activeBreakpoint) {
                return false;
            }

            // Handle the transition from last slide back to first slide.
            $('.slick-slide').removeClass('slick-slide-visible');
            const slidesToShow = slick.breakpointSettings[slick.activeBreakpoint].slidesToShow;
            
            if (0 === nextSlide) {
                for (var i = 0; i < slidesToShow; i++) {
                    $(event.currentTarget).find('.slick-cloned[data-slick-index="' + (currentSlide + slidesToShow + i) + '"]').addClass('slick-slide-visible');
                }
            }
            // This means we're looping back from the beginning to the end.
            if (slick.slideCount - slidesToShow === nextSlide) {
                for (var i = 1; i <= slidesToShow; i++) {
                    $(event.currentTarget).find('.slick-cloned[data-slick-index="' + i * -1 + '"]').addClass('slick-slide-visible');
                }
            }
        });

    }, false);

})(jQuery);